import { axiosClient } from "../axios";
import { getQuery } from "../helper";

const baseUrl = "/api/registry/users";

export function getAllFromFirm(firmId = undefined) {
  const query = getQuery({ firmId });
  return axiosClient.get(`${baseUrl}/firm`, query);
}

export function getByEnterpriseId(enterpriseId) {
  const query = getQuery({ enterpriseId });
  return axiosClient.get(`${baseUrl}/enterprises`, query);
}

export function toggle(userId) {
  return axiosClient.post(`${baseUrl}/${userId}/toggle`);
}

export function changePassword(data) {
  return axiosClient.post(`${baseUrl}/password/change`, data);
}

export function sendValidationEmail(userId) {
  return axiosClient.post(`${baseUrl}/${userId}/registration-token/reset`);
}

export function getUserEnterprises(userId) {
  return axiosClient.get(`${baseUrl}/${userId}/enterprises`);
}

export function updateUserEnterprises(userId, enterpriseIds) {
  return axiosClient.put(`${baseUrl}/${userId}/enterprises`, { enterpriseIds });
}
